import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import titleMixin from "./mixins/titleMixin";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component("font-awesome-icon", FontAwesomeIcon);

// Buefy
import Buefy from "buefy";

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});

// Mixins
Vue.mixin(titleMixin);

// Axios
import axios from "axios";

Vue.prototype.$http = axios;
const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

// API Key
Vue.prototype.$http.defaults.headers.common["api-key"] =
  "KKQH1j2I3F4SucJfm6maEk2I7o8q0nEk";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
